import React, { useState } from "react";
import LazyLoad from "react-lazyload";
 import { Link } from "react-router-dom";

const ClassTabs = () => {
    // State to keep track of the active tab
    const [activeTab, setActiveTab] = useState(0);

    // Array of tab data including images and content
    const tabData = [
        {
            image: "https://webapi.entab.info/api/image/STPSFH/public/Images/pre-primary.png", // Use the imported image
            title: <>Pre primary <br /> School</>,
            content: "The Foundational Stage focuses on nurturing the curiosity and creativity inherent in young learners. At this stage, we aim to build a strong foundation in language development, particularly in reading, writing, and speaking, while fostering social and emotional development. Through play-based learning, children engage in hands-on activities that stimulate their imagination and encourage critical thinking and problem-solving. ",
            readMore: '/PriPrimarySchool'
        },
        {
            image: "https://webapi.entab.info/api/image/STPSFH/public/Images/primary.png", // Use the imported image
            title: <>Primary <br />School</>,
            content: "In the Preparatory Stage, the focus shifts to building cognitive abilities and conceptual understanding. We emphasize interactive learning, where students move from learning basic concepts to critical thinking and independent learning. Through hands-on activities, experiments, and project-based learning, students gain a deeper understanding of subjects such as mathematics, science, social studies, and languages. ",
            readMore: '/PrimarySchool'
        },
        {
            image: "https://webapi.entab.info/api/image/STPSFH/public/Images/middle-school.png", // Use the imported image
            title: <>Middle<br /> School</>,
            content: " The Middle Stage is where students begin to refine their academic skills and prepare for more complex learning experiences. At this stage, students are encouraged to think critically and apply their knowledge in real-world contexts. We focus on project-based learning, where interdisciplinary topics are explored in depth, and students begin to take responsibility for their learning through independent and collaborative research projects.",
            readMore: '/MiddleSchool'
        },
        {
            image: "https://webapi.entab.info/api/image/STPSFH/public/Images/secondary.png", // Use the imported image
            title: <>Secondary <br />School</>,
            content: " The Secondary Stage focuses on academic rigor while preparing students for the Class X board exams. In this stage, students are expected to take ownership of their learning and refine their skills in critical thinking, problem-solving, and decision-making. In addition to the core subjects, we focus on the development of life skills, leadership qualities, and ethical values, ensuring students are well-rounded individuals ready for higher education or the professional world.",
            readMore: '/SecondarySchool'
        },
        {
            image: "https://webapi.entab.info/api/image/STPSFH/public/Images/sr-secondary.png", // Use the imported image
            title: <>Sr Secondary <br />School</>,
            content: " St. Peter's Convent School, Sector 88, Greater Faridabad is a recognized unaided Christian minority institution, established in 2013. Affiliated to the Central Board of Secondary Education (CBSE), New Delhi (Affiliation No. 531674, School Code 41651), the school provides a nurturing environment focused on academic excellence, character formation, and the holistic growth of every student.",
            readMore: '/SrSecondarySchool'
        } 
    ];

    return (
        <div className="class-tabs">
            <div className="tabs">
                {tabData.map((tab, index) => (
                    <div
                        key={index}
                        className={`tab ${activeTab === index ? "active" : ""}`}
                        onClick={() => setActiveTab(index)}
                    >
                   
                        <div className="tabs-img">
                            <LazyLoad><img src={tab.image} alt={tab.title} className="tab-image" /></LazyLoad>
                        </div>
                        <div className="tab-title">{tab.title}</div>
                    </div>
                ))}
            </div>
            <div className="tabs-content">
                <div className="content"> 
                    <p>{tabData[activeTab].content}</p>
                      <button className="button"> <Link to={tabData[activeTab].readMore}> Read More  <i className="bi bi-arrow-right"></i> </Link></button>  
                </div>
            </div>
        </div>
    );
};

export default ClassTabs;
